// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bcac29e9","455":"0102bfbd"}[chunkId] + ".chunk.js";
};